import { render, staticRenderFns } from "./call_center.vue?vue&type=template&id=714a00df&"
import script from "./call_center.vue?vue&type=script&lang=js&"
export * from "./call_center.vue?vue&type=script&lang=js&"
import style0 from "./call_center.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports